import { connect } from 'react-redux'
import requestAddLabel from '../../../sagas/requestAddLabel'
import AddLabel from './AddLabel'
import { withBoardContext } from 'dataProviders/Board'

export default withBoardContext(connect(
  null,
  {
    requestAddLabel
  }
)(AddLabel))
